import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import pluralize from 'pluralize';

const PageInfo = ({ className, currentPage, itemCount, itemSingularLabel, pageSize, totalCount }) => {
  if (!itemSingularLabel) {
    return null;
  }

  let label;

  if (totalCount === 0) {
    label = `No ${pluralize(itemSingularLabel)} found`;
  } else {
    const itemCountLabel = pluralize(itemSingularLabel, totalCount, true);

    if (totalCount <= pageSize) {
      label = `Displaying ${itemCountLabel}`;
    } else {
      const lowerBound = (currentPage - 1) * pageSize + 1;
      const upperBound = Math.min(lowerBound + itemCount - 1, totalCount);
      label = `Displaying ${lowerBound} - ${upperBound} of ${itemCountLabel}`;
    }
  }

  return (
    <div className={classNames('page-info', 'text-muted', className)}>
      {label}
    </div>
  );
};

PageInfo.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number,
  itemCount: PropTypes.number,
  itemSingularLabel: PropTypes.string,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number
};

export default PageInfo;

